import { useDate } from 'Globals/useDate'
import { ChartFrame } from 'components/ChartFrame'
import ChartSelector from 'components/ChartSelector'
import { global_locales } from 'components/constants'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const locales = global_locales.wastewatercovid
const foot_locales = global_locales.wastewater
export const WasteWaterCovid = ({
  colorMode,
  lang,
}: {
  colorMode: 'dark' | 'light' | undefined
  lang: 'de' | 'fr'
}) => {
  const endDate = useDate()
  const [selected, setSelected] = useState(
    lang === 'de' ? 'Werdhölzli (ZH)' : 'Genève'
  )


  return (
    <WasteWaterCovidRoot>
      <ChartFrame
        lang={lang}
        title={locales[lang].title}
        footnote={
          <>
            {foot_locales[lang].stations.all}{' '}
            {foot_locales[lang].stations[selected]}
          </>
        }
        timestamp={
          <>
            {new Date(endDate).toLocaleDateString(lang + '-CH', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            })}
          </>
        }
        lead={locales[lang].lead}
        source={locales[lang].source}
        colorMode={colorMode}
      >
        <ChartSelector
          colorMode={colorMode}
          lang={lang}
          data={'covid'}
          selected={selected}
          setSelected={setSelected}
        />
      </ChartFrame>
    </WasteWaterCovidRoot>
  )
}

const WasteWaterCovidRoot = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  /* background-color: red; */
`
